export default __webpack_public_path__ + "static/image18-460d97ba81da3af03ecb04df511fc835.gif";